import { assetLoader, audioPlayer, flump } from "../PhaserExtension";
import * as States from "./States";
import * as GameModel from "../models/GameModel";
import BaseState from "./BaseState";
import FlumpObject from "../general/objects/FlumpObject";
import PostgameGrover from "../postgame/objects/PostgameGrover";

export default class CongratulationState extends BaseState
{
    preload()
    {
        assetLoader.preloadAssetPacks(this.game, ["congrats"]);
        super.preload();
    }

    create()
    {
        this.config = this.game.cache.getJSON("congratsConfig");
        flump.addLibrary(this.game, "storyCircleFlump", "assets/storyCircle/flump/");
        audioPlayer.setupChannels(this.config.sounds.channels);
        audioPlayer.play(this.game, this.config.sounds.music);

        let background = new Phaser.Sprite(this.game, 0, 0, this.config.assets.background.display.key);
        this.backgroundLayer.add(background);

        this.grover = new PostgameGrover(this.game, this.config.assets.grover, "groverFlump");
        this.maingroundLayer.add(this.grover);

        let muppets = this.config.assets.muppets;
        for(let i = 0; i < muppets.length; i++)
        {
            let muppet = new FlumpObject(this.game, muppets[i], "storyCircleFlump");
            this.backgroundLayer.add(muppet);
        }

        GameModel.data.storiesPlayed += 1;
        GameModel.data.currentStateName = "Story recap screen";

        super.create();
    }

    onTransitionInComplete()
    {
        audioPlayer.play(this.game, this.config.sounds.sfx);
        audioPlayer.play(this.game, this.config.sounds.congratulations, this.transistionOut, this);
        GameModel.data.groverTransition = 0;
    }

    onTransitionOutComplete()
    {
        this.game.state.start(States.RECAP);
    }

    shutdown()
    {
        flump.removeLibrary("storyCircleFlump");
        audioPlayer.cleanupChannels(this.config.sounds.channels);
        assetLoader.unloadAssetPacks(this.game, ["intro"]);
        delete this.grover;
        super.shutdown();
    }
}
